import React, { useContext } from 'react'
import { Redirect, Route } from 'react-router-dom'

import { AuthContext } from '@/contexts/Auth'

const PrivateRoute = function({ component: Component, ...rest }) {
  const { authed } = useContext(AuthContext)
  return (
    <Route
      {...rest}
      render={props =>
        authed ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        )
      }
    />
  )
}
export default PrivateRoute
